<template>
  <span class="project-list">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-select v-model="runningStatus" popper-class="statusPopper" placeholder="状态" size="small"
                   @change="changeParams()" style="width: 0.4rem;">
          <el-option v-for="item in statusOptions" :key="item.id" :label="item.name" :value="item.id">
            <span style="float: left;">
              <img
                :src="item.id==274?'/static/images/svolt/runningImg.png':item.id==275?'/static/images/svolt/shutdownImg.png':item.id==276?'/static/images/svolt/buildingImg.png':item.id==300?'/static/images/svolt/debugImg.png':''"
                alt="" style="width: 12px;margin-right: 5px;">
            </span>
            <span>{{item.name}}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input class="filter-input" placeholder="搜索" v-model="filterText" @input="changeParams()" size="small" style="width: 1.25rem;"><i
          slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
      </el-form-item>
    </el-form>
    <el-tree class="filter-tree" :data="treeData" :props="defaultProps" default-expand-all
             :filter-node-method="filterNode" highlight-current ref="tree" @node-click="handleNodeClick">
      <template slot-scope="{ node, data }">
        <span v-if="node.label.length<20">
          <p class="treeLabel" v-if="data.projectId != ''">
            <img
              :src="data.projectStatus==274?'/static/images/svolt/runningImg.png':data.projectStatus==275?'/static/images/svolt/shutdownImg.png':data.projectStatus==276?'/static/images/svolt/buildingImg.png':data.projectStatus==300?'/static/images/svolt/debugImg.png':''"
              alt="" style="width: 12px;margin-right: 5px;">
            {{node.label}}
          </p>
          <p class="treeLabel" v-if="data.projectId == ''">
            {{node.label}}
            <span style="position: absolute;right: 5px;">({{projectCount}})</span>
          </p>
        </span>
        <el-tooltip v-else effect="light" :content="node.label" placement="right">
          <p class="treeLabel" v-if="data.projectId != ''">
            <img
              :src="data.projectStatus==274?'/static/images/svolt/runningImg.png':data.projectStatus==275?'/static/images/svolt/shutdownImg.png':data.projectStatus==276?'/static/images/svolt/buildingImg.png':data.projectStatus==300?'/static/images/svolt/debugImg.png':''"
              alt="" style="width: 12px;margin-right: 5px;">
            {{node.label}}
          </p>
          <p class="treeLabel" v-if="data.projectId == ''">
            {{node.label}}
            <span style="position: absolute;right: 5px;">({{projectCount}})</span>
          </p>
        </el-tooltip>
      </template>
    </el-tree>
  </span>
</template>

<script>
  import USERAPI from '@/api/user';
  export default {
    props: {
      projectListData: {
        type: Array
      },
      currStatus: ''
    },
    data() {
      return {
        runningStatus: this.currStatus,
        statusOptions: [{
          id: '',
          img: '',
          name: '全部'
        }, {
          id: 274,
          name: '投运'
        }, {
          id: 300,
          name: '调试'
        }, {
          id: 276,
          name: '在建'
        }, {
          id: 275,
          name: '离线'
        }],
        filterText: '',
        treeData: this.projectListData,
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        projectCount: 0
      }
    },
    watch: {
      filterText(val) {
        if (val == '') {
          this.projectCount = this.projectListData[0].children.length;
        } else {
          this.projectCount = 0;
        }
        this.$refs.tree.filter(val);
      },
      projectListData(val) {
        this.treeData = val;
        this.projectCount = val[0].children.length;
      }
    },
    mounted() {
      this.treeData[0].children.map((item) => {
        item.isShow == 1 ? item.disabled = false : item.disabled = true;
      })
      this.projectCount = this.projectListData[0].children.length;
    },
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        if (data.name.indexOf(value) !== -1) {
          this.projectCount++;
        }
        return data.name.indexOf(value) !== -1;
      },
      changeParams() {
        this.$emit("changeParams", [this.runningStatus, this.filterText]);
      },
      // 隔行变色
      changeColor() {
        var content = document.getElementsByClassName('el-tree-node__content');
        for (var i = 0; i < content.length; i++) {
          if (i % 2 === 0) {
            content[i].style.background = '';
          } else {
            content[i].style.background = '#DAE7FF';
          }
        }
      },
      handleNodeClick(node) {
        if (node.isShow == 1) {
          if (node.projectId != '') {
            let params = {
              projectId: node.projectId,
              resourceId: 2
            };
            USERAPI.searchUserResources(params).then(res => {
              //保存权限模块
              localStorage.removeItem('ActiveProjectModule');
              let activeModule = {
                resourceIds: [],
                item: []
              };
              if (res.data.code == 200 && !res.data.errors) {
                let data = res.data.data;
                data.forEach(item => {
                  activeModule.resourceIds.push(item.resourceId);
                  activeModule.item.push({
                    checked: item.checked,
                    resourceId: item.resourceId,
                    resourceNameShow: item.resourceNameShow,
                    showOrder: item.showOrder
                  });
                  //增加二级展示
                  if (item.children && item.children.length > 0) {
                    item.children.forEach(n => {
                      activeModule.resourceIds.push(n.resourceId)
                      activeModule.item.push({
                        checked: n.checked,
                        resourceId: n.resourceId,
                        resourceNameShow: n.resourceNameShow,
                        showOrder: n.showOrder
                      });
                    })
                  }
                });
                localStorage.setItem('ActiveProjectModule', JSON.stringify(activeModule));
                this.$router.push({
                  name: 'SvoltProject',
                  query: {
                    projectId: node.projectId
                  }
                });
              }
            });
          }
        } else {
          this.$message({
            dangerouslyUseHTMLString: true,
            showClose: true,
            message: '用户未授权！该项目数据不对其他用户开放，请见谅！',
            type: 'warning'
          });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .project-list {
    width: calc(100% - 40px);
    left: 20px;
    margin-top: 45px;
    overflow: auto;
    position: absolute;

    .filter-input {
      width: 320px;
      position: fixed;

      >>>.el-input__inner {
        border-color: #5A9CF8;
        padding-left: 15px !important;
      }
    }

    .filter-tree {
      width: 320px;
      height: 38vh;
      overflow: auto;
    }

    .el-form-item {
      margin-bottom: 15px !important;
    }

    .el-form--inline .el-form-item {
      margin-right: 0px !important;
    }
  }
</style>
<style lang="scss">
  .project-list .el-icon-caret-right:before {
    color: #4CACD5;
  }

  .project-list .el-tree {
    background: #fbfcff;
  }

  .project-list .el-tree-node__content {
    height: 30px;

    .treeLabel {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #08265F;
    }
  }

  .project-list .el-tree-node__children {
    .el-tooltip {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #08265F;
    }

    .treeLabel {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #08265F;
    }
  }

  .project-list .el-tree-node__expand-icon.is-leaf {
    visibility: hidden;
  }

  .project-list .el-tooltip {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .project-list {
    .el-input--small .el-input__inner {
      border: 1px solid #5A9CF8;
      color: #08265F;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/project-list.vue